// src/auth/AppContent.js
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { verifyUser } from "../store/Auth/authThunks";
import { useNavigate, Outlet } from "react-router-dom";

import AppTheme from "../theme/AppTheme";
import { ThemeSettingsProvider } from "../theme/ThemeSettingsContext";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { setLogoutCallback } from "../api/logoutHandler";
import { handleAuthFailure } from "../utils/authUtils";
import SessionExpiredDialog from "../components/SessionExpiredDialog";
import TrainingVideoGate from "../pages/Users/Components/TrainingVideoGate";

export default function AppContent({ children }) {
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();

  const authLoading = useSelector((state) => state.auth.loading);
  const authInitialized = useSelector((state) => state.auth.initialized);
  const user = useSelector((state) => state.auth.user);

  const navigate = useNavigate();
  const [sessionExpired, setSessionExpired] = useState(false);
  const [sessionReason, setSessionReason] = useState("");
  const [showTrainingVideo, setShowTrainingVideo] = useState(false);

  useEffect(() => {
    setLogoutCallback(() => async () => {
      await handleAuthFailure(navigate, setSessionReason);
      setSessionExpired(true);
    });
  }, [navigate]);

  useEffect(() => {
    dispatch(
      verifyUser({
        instance,
        account: accounts[0],
      })
    );
  }, [dispatch, instance, accounts]);

  useEffect(() => {
    if (authInitialized && user && user.has_seen_training_video === false) {
      setShowTrainingVideo(true);
    }
  }, [authInitialized, user]);

  if (!authInitialized || authLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (showTrainingVideo) {
    return (
      <TrainingVideoGate
        onComplete={() => {
          setShowTrainingVideo(false);
          dispatch(
            verifyUser({
              instance,
              account: accounts[0],
            })
          );
        }}
      />
    );
  }

  return (
    <ThemeSettingsProvider>
      <AppTheme>
        <Box
          display="flex"
          flexDirection="column"
          sx={{ width: "100vw", height: "100vh" }}
        >
          {children ?? <Outlet />}
        </Box>

        <SessionExpiredDialog
          open={sessionExpired}
          reason={sessionReason}
          onClose={() => setSessionExpired(false)}
        />
      </AppTheme>
    </ThemeSettingsProvider>
  );
}
